import React from 'react';
import { Container } from 'reactstrap';
import Misc from '../base/components/Misc';


function BugReportPage() {
	const blocked = Misc.CheckAccess({ can: 'editAdvert' });
	if (blocked) return blocked;

	return (
	<Container className="text-center">
		<h1>Report a bug</h1>
		<p>Use the form below to add a bug report to Monday.</p>
		
		<iframe src="https://forms.monday.com/forms/embed/533e07e907912de3b4ba268150204cac?r=use1"
			title="Bug Report Monday Form" width={850} height={960}
			style={{border: "0", boxShadow: "5px 5px 56px 0px rgba(0,0,0,0.25)"}}
		/>
	</Container>);
}

export default BugReportPage;
